const symbol = (value) => {
  if (!value) return ''
  return !value.split('').includes('-') ? value : value.split('').splice(0, value.split('').findIndex(x => x === '-')).join('').toString();
}

export { symbol }